var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "loginForm"
  }, [_c('div', {
    staticClass: "type"
  }, _vm._l(_vm.loginType, function (type, index) {
    return _c('span', {
      key: index,
      class: {
        active: _vm.typeIndex === index
      },
      on: {
        "click": function ($event) {
          return _vm.handleTabClick(index);
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(type)))]);
  }), 0), _vm._v(" "), _c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.typeIndex === 0 && !_vm.showChooseStore,
      expression: "typeIndex === 0 && !showChooseStore"
    }],
    ref: "formAccount",
    staticClass: "accountLogin",
    attrs: {
      "model": _vm.formAccount,
      "rules": _vm.ruleAccount
    }
  }, [_c('FormItem', {
    staticClass: "inputBox",
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('login.placeholderAccount')
    },
    model: {
      value: _vm.formAccount.account,
      callback: function ($$v) {
        _vm.$set(_vm.formAccount, "account", $$v);
      },
      expression: "formAccount.account"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": "",
      "placeholder": _vm.$t('login.placeholderPwd')
    },
    model: {
      value: _vm.formAccount.pwd,
      callback: function ($$v) {
        _vm.$set(_vm.formAccount, "pwd", $$v);
      },
      expression: "formAccount.pwd"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "identifyCode",
    attrs: {
      "prop": "captcha"
    }
  }, [_c('img', {
    staticClass: "img-code",
    attrs: {
      "src": _vm.accountImageCodeBase64,
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.getImageCode(0);
      }
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "1.5rem",
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('login.placeholderCode2')
    },
    model: {
      value: _vm.formAccount.captcha,
      callback: function ($$v) {
        _vm.$set(_vm.formAccount, "captcha", $$v);
      },
      expression: "formAccount.captcha"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "loginBtnBox"
  }, [_c('button', {
    staticClass: "myBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formAccount');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("login.login")) + "\n        ")])])], 1), _vm._v(" "), _c('Form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.typeIndex === 1,
      expression: "typeIndex === 1"
    }],
    ref: "formPhone",
    staticClass: "accountLogin",
    attrs: {
      "model": _vm.formPhone,
      "rules": _vm.rulePhone
    }
  }, [_c('FormItem', {
    staticClass: "inputBox",
    attrs: {
      "prop": "area"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": _vm.$t('login.placeholderArea')
    },
    model: {
      value: _vm.formPhone.area,
      callback: function ($$v) {
        _vm.$set(_vm.formPhone, "area", $$v);
      },
      expression: "formPhone.area"
    }
  }, _vm._l(_vm.areaList, function (item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]);
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('login.placeholderCodeLogin')
    },
    model: {
      value: _vm.formPhone.account,
      callback: function ($$v) {
        _vm.$set(_vm.formPhone, "account", $$v);
      },
      expression: "formPhone.account"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "code"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": _vm.$t('login.placeholderCode')
    },
    model: {
      value: _vm.formPhone.code,
      callback: function ($$v) {
        _vm.$set(_vm.formPhone, "code", $$v);
      },
      expression: "formPhone.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('SendCode', {
    ref: "sendCode",
    nativeOn: {
      "click": function ($event) {
        return _vm.sendCode.apply(null, arguments);
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "identifyCode",
    attrs: {
      "prop": "captcha"
    }
  }, [_c('img', {
    staticClass: "img-code",
    attrs: {
      "src": _vm.codeLoginImageBase64,
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.getImageCode(1);
      }
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "1.5rem",
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('login.placeholderCode2')
    },
    model: {
      value: _vm.formPhone.captcha,
      callback: function ($$v) {
        _vm.$set(_vm.formPhone, "captcha", $$v);
      },
      expression: "formPhone.captcha"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "loginBtnBox"
  }, [_c('button', {
    staticClass: "myBtn",
    attrs: {
      "type": "button",
      "disabled": _vm.clicked
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formPhone');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("login.login")) + "\n        ")])])], 1)], 1), _vm._v(" "), _vm.showChooseStore ? _c('div', {
    staticClass: "chooseStore"
  }, [_c('h2', {
    staticClass: "tc"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sc.components.chooseStore")) + "\n    ")]), _vm._v(" "), _c('Select', {
    staticClass: "select",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.store,
      callback: function ($$v) {
        _vm.store = $$v;
      },
      expression: "store"
    }
  }, _vm._l(_vm.stores, function (item) {
    return _c('Option', {
      key: item.storeId,
      attrs: {
        "value": JSON.stringify(item)
      }
    }, [_vm._v("\n        " + _vm._s(item.storeName) + "\n      ")]);
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "tc",
    staticStyle: {
      "margin-top": "0.8rem"
    }
  }, [_c('Button', {
    on: {
      "click": _vm.storeLogin
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("sc.components.login")) + "\n      ")])], 1)], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }